import styled from 'styled-components'

export const DeviceSetTitleWrapper=styled.div` 
    padding: 2rem 2rem 0 2rem;/** 无root 元素，无法获取 */
    
    >.ant-space {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .ant-space-item:first-child {
            width: calc(100% - 2px);
        }
        @media (max-width: 768px) {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center !important;
            align-items: center;
            .ant-space-item {
                width: 100% !important;
            }
        }
    }
`

export const TitleWrapper=styled.div`
    .ant-divider.ant-divider-with-text {
        border-top-color: rgb(0 0 0 / 2.5%);/** 无root 元素，无法获取 */
        @media (max-width: 768px) {
            &::before,
            &::after {
                top: 50% !important;
                width: 50% !important;
            }
            >span.ant-divider-inner-text {
                padding: 0 14px;/** 无root 元素，无法获取 */
            }
        }
    }    
`

export const DeviceIconTitleWrapper=styled.div`
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        gap: var(--gap-8);
        @media (max-width: 768px) {
            flex-direction: column;
            justify-content: center;
        }

        .ant-avatar {
            width: 56px;/** 无root 元素，无法获取 */
            height: 56px;/** 无root 元素，无法获取 */
            line-height: 56px;/** 无root 元素，无法获取 */
            border-radius: 50%;/** 无root 元素，无法获取 */

            border: none;

            box-sizing: border-box;

            .icon-svg {
                width: 100%;

                color: var(--white-100);
                fill: var(--white-100);
                background: linear-gradient(var(--sky-100) 0%, var(--lake-100) 100%);
                font-size: 22px;/** 无root 元素，无法获取 */
                margin-right: 0;

                /* 采集器图标特定定位样式 换图标需重新调整定位样式 */
                >div>svg {
                    margin-top: -2px;/** 无root 元素，无法获取 */
                }
            }

            &.loggerOnline {
                box-shadow: 0 0 24px var(--white-100);
                .icon-svg {
                    color: var(--loggerOnline-color);
                    fill: var(--loggerOnline-color);

                    background: radial-gradient(circle, var(--white-100) calc(100% - 24px), var(--loggerOnline-light-color) 100%);
                }
            }

    
            &.loggerOffline {
                .icon-svg {
                    color: var(--loggerOffline-color);
                    fill: var(--loggerOffline-color);

                    background: radial-gradient(circle, var(--white-100) calc(100% - 24px), var(--loggerOffline-light-color) 100%);
                }
            }
        }
`

export const TitleTextWrapper=styled.div`
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: flex-start;
        gap: 0;
        @media (max-width: 768px) {
            justify-content: center;
            align-items: center;
        }

        .ant-typography {
            &:nth-child(1) {
                font-size:  var(--fontsize-12);
            }
            &:nth-child(2) {
                font-family: 'Arial Narrow';
                font-size: var(--fontsize-24);
                letter-spacing: 1.2px;
                > * {
                 padding: 0 var(--gap-8);
                }
            }
        }
`

export const ButtonWrapper=styled.div`
    .ant-btn {
        min-width: var(--wh-138);
    }
    @media (max-width: 768px) {
        text-align: center;
        justify-content: center;
    }
`
export const RowWapper = styled.div`
    .ant-typography-danger {
        display: block;
        font-size: var(--fontsize-12);
        text-align: end;
    }
`

export const RowUpgradeWapper = styled.div` 
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .ant-typography {
      height: var(--wh-24);
    }
    .ant-typography-success {
        color: var(--default-color);
    }
    .ant-typography-warning {
        color: var(--offline-color) !important;
    }
`

export const UpgradeTargetVersionWapper = styled.div` 
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
`

export const InUpgradingWapper = styled.div` 
    display: flex;
    align-items: center;
    flex-direction: column;
    .ant-typography:nth-child(3) {
      margin-top: var(--gap-16);
    }
    .ant-typography:nth-child(4) {
      display: flex;
      align-items: center;
      gap: var(--gap-4);
      font-weight: 300;/** 无root 元素，无法获取 */
    }
`

export const SuccessWapper = styled.div` 
    .ant-result-subtitle {
        margin-top: 36px;/** 无root 元素，无法获取 */
        color: var(--font-000);
    }
`

export const DividerCenterSMButtonWrapper = styled.div` 
    display: flex;
    justify-content: center;
    width: 100%;
`

export const EnterPasswordPlaceholder = styled.div`
    height: var(--wh-80);

    .ant-input-affix-wrapper {
        margin-bottom: var(--gap-8);
    }

    && {
        .ant-form-item-explain,
        .ant-form-item-explain-error,
        .ant-form-item-explain-connected,
        div[class*="explain"] {
            animation: none !important;
            transition: all 0s !important;
            animation-duration: 0s !important;
            animation-fill-mode: none !important;
        }
    }
    
    .ant-form-item-explain-error {
        display: flex;
        justify-content: center;
        font-size: var(--fontsize-12);
    }
`